import { mapUsPortfolioOrder } from './portfolioClient';
import type { UsClientPreview, UsSubmitResult } from './tradingClient';
import type { UsReceipt, UsScope } from './types';

/** Convert the validated client preview to #988's presenter contract. A fee
 * reserve is not an estimated commission or a complete cash-effect estimate. */
export function mapUsTicketPreview(preview: UsClientPreview) {
  return {
    draftRevision: preview.draftRevision,
    scopeKey: preview.scopeKey,
    expiresAt: new Date(preview.expiresAtMs).toISOString(),
    timeEvidence: preview.timeEvidence,
    estimatedFeeUsd: preview.estimatedFeeUsd,
    estimatedCashEffectUsd: null,
    warnings: [] as readonly string[],
  };
}

export type UsTicketResult = {
  requestKey: string;
  /** Null means the relay intent is not known. Never substitute requestKey. */
  receipt: UsReceipt | null;
  /** A transport/read uncertainty can coexist with a known saved receipt. */
  lookupReason: string | null;
};

/** No request, retry, storage mutation or acknowledgment. The connected ticket
 * keeps local recovery markers until a receipt has actually been presented.
 * Use the portfolio's status mapping so the ticket cannot invent acceptance. */
export function mapUsTicketResult(
  result: UsSubmitResult,
  accountId: string,
  scope: UsScope,
): UsTicketResult {
  return {
    requestKey: result.requestKey,
    receipt: result.order
      ? mapUsPortfolioOrder({ ...result.order, cancel: null }, accountId, scope, 'own').receipt
      : null,
    lookupReason: result.kind === 'unconfirmed' ? result.code : null,
  };
}
